module.exports = __webpack_public_path__ + "img/integrity-black.38fdc21e.svg";